import { colors } from '../../colors';
var socialIcon = {
  fillColor: colors.white,
  fillHoverColor: colors.white,
  iconColor: colors.slateGreen,
  iconHoverColor: colors.militaryGreen,
  iconBorderColor: colors.slateGreen,
  iconBorderHoverColor: colors.militaryGreen
};
export default socialIcon;